

























































































import {
  Component, Vue, Watch, mixins, mapState,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import {
  AdvertisementsStore, AuthorizationStore, CommonsStore, Payload, MyaaffiliateStore,
} from '@/state/modules';
import {
  formatDate, getEndDayOfDate, getStartDayOfDate,
} from '@/utils/date-utils';
import { _filter, _isEmpty } from '@/plugins/lodash';

class MediaTrafficState {
  public casino: string | number = ''

  public campaign: string | number = ''

  public landingpage: string = ''

  public dayPeriod: Array<string> = [getStartDayOfDate(), getEndDayOfDate()]

  public advertisementCategoryId: string | number = ''

  public display: number = 0

  public isExporting: Boolean = false
}

    @Component({
      /**
         * Imported components
         * */
      components: {},
      /**
         * Stores values
         * */
      computed: {
        ...mapState({
          campaignList: (state: any) => state.advertisements.advertisementsStore.campaignList,
          loading: (state: any) => state.advertisements.advertisementsStore.loading,
          adsStats: (state: any) => state.advertisements.advertisementsStore.adsStats,
        }),
      },
      /**
         * Component properties
         * */
      props: {},
    })
export default class MediaTraffic extends mixins(SamclickMixins) {
        /**
         * Local state
         * */
        state = new MediaTrafficState();

        payloadTemp = {};

        activeCasinos: { id: number, code: string }[] = []

        /**
         * Watchers
         * */
        @Watch('componentState.var')
        sampleWatcher(newVal: string, oldVal: string) {

        }

        @Watch('state.advertisementCategoryId')
        advertisementCategoryWatcher(newVal: object, oldVal: object) {
          if (newVal !== oldVal) {
            this.state.campaign = '';
          }
        }

        /**
         * Methods
         * */
        search() {
          const {
            display, dayPeriod, casino, campaign, landingpage, advertisementCategoryId,
          } = this.state;
          const startDate = dayPeriod[0];
          const endDate = getEndDayOfDate(dayPeriod[1]);

          if (_isEmpty(startDate)) {
            this.showAlert('Date is Required!', this.$data.SamclickAlert.ERROR);
            return;
          }

          const payload = {
            startDate,
            endDate,
            casinoID: casino,
            campaignID: campaign,
            landingpage,
            monthly: display,
            advertisementCategoryId,
          };
          this.payloadTemp = payload;
          AdvertisementsStore.advertisementStats(new Payload(payload));
        }

        getCasinoWithDaySales() {
          MyaaffiliateStore.GetCasinosWithDaySales(new Payload({
            affiliate_id: this.getAffiliateID,
          })).then((response: any) => {
            if (response.data) {
              this.activeCasinos = response.data;
            } else {
              this.activeCasinos = [];
            }
          });
        }

        get getAffiliateID() {
          let affiliate_id = AuthorizationStore.currentLoggedUserInState.id;
          if (affiliate_id === undefined || affiliate_id === null) {
            const local_json_string = localStorage.getItem('ma-auth.currentUser') as string;
            affiliate_id = JSON.parse(local_json_string).id;
          }

          return affiliate_id;
        }

        reset() {
          this.state = new MediaTrafficState();
          this.search();
        }

        exportCsv() {
          this.state.isExporting = true;
          const {
            dayPeriod, casino, campaign, landingpage, advertisementCategoryId,
          } = this.state;

          let casino_ids: (string | number)[] = []
          if (casino !== 0 && casino !== '') {
            casino_ids = [casino]
          } else {
            casino_ids = this.activeCasinos.map((casino) => casino.id);
          }

          const startDate = dayPeriod[0];
          const endDate = getEndDayOfDate(dayPeriod[1]);

          const payload = {
            start_date: startDate,
            end_date: endDate,
            casino_ids,
            campaignID: campaign,
            affiliate_id: this.getAffiliateID,
            landing_page: landingpage,
            advertisement_category_id: advertisementCategoryId,
            headers: [
              this.$t('label.date'),
              this.$t('label.brand'),
              this.$t('media.campaign_category'),
              this.$t('label.campaign'),
              this.$t('label.landingpage'),
              this.$t('label.impression'),
              this.$t('label.hits'),
              this.$t('label.click_ratio', { sign: '(%)' }),

            ],
          };
          this.payloadTemp = payload;
          AdvertisementsStore.exportMediaTraffic(new Payload(payload)).finally(() => {
            this.state.isExporting = false;
          });
        }

        /**
         * Computed
         * */

        get advertisementCategories() {
          return CommonsStore.allAdvertisementCategories;
        }

        get campaignListPerCategory() {
          const { advertisementCategoryId } = this.state;
          if (advertisementCategoryId !== '') {
            return _filter(this.campaignList, { advertisementCategoryId });
          }
          return this.campaignList;
        }


        /**
         * Lifecycle hooks
         * */
        created() {
          this.getCasinoWithDaySales();
          this.search();
        }

        mounted() {
        }

        beforeUpdate() {
        }

        beforeCreate() {
          this.dateUtils = {
            formatDate,
          };
          CommonsStore.fetchAllCasino();
          AdvertisementsStore.getCampaignList(new Payload({ affiliateId: AuthorizationStore.currentLoggedUserInState.id, status: 1 }));
          CommonsStore.fetchAllAdsCategory();
        }
}
